import type { ClientUser } from '../contexts/ClientAuthContext';

/** Where to send a CP user after login or password change. */
export function clientPortalHomePath(user: ClientUser | null): string {
  if (!user) return '/client/login';
  if (user.mustChangePassword) return '/client/change-password';
  if (user.onboardingPhase !== 'operational') return '/client/agreements';
  return '/client/dashboard';
}
